import React, { useState, useEffect } from "react";
import { Tooltip } from "antd";

// Utility to detect touch devices
const isTouchDevice = () =>
  typeof window !== "undefined" &&
  ("ontouchstart" in window || navigator.maxTouchPoints > 0);

const CustomTooltip = ({ children, title, ...rest }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Hide tooltip on "modal-open" event
    const hideTooltip = () => setVisible(false);
    window.addEventListener("modal-open", hideTooltip);
    return () => {
      window.removeEventListener("modal-open", hideTooltip);
    };
  }, []);

  const handleOpenChange = (v) => {
    if (isTouchDevice()) {
      setVisible(v);
    }
  };

  const handleClick = () => {
    if (isTouchDevice()) {
      setVisible(false); // close tooltip on click for touch
    }
  };

  if (isTouchDevice()) {
    return (
      <Tooltip
        title={title}
        open={visible}
        onOpenChange={handleOpenChange}
        {...rest}
      >
        <div onClick={handleClick} className="inline-block">
          {children}
        </div>
      </Tooltip>
    );
  }

  // Default behavior for desktop
  return (
    <Tooltip title={title} {...rest}>
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
